import Amplify, { API, graphqlOperation } from "aws-amplify";
import awsconfig from "../aws-exports";
import { createAgentResponse } from "../graphql/mutations";

Amplify.configure(awsconfig);

const testInput = {
  action: "Log",
  agent: "BADGE001",
  userId: "EXTERNALUUID001",
  QRCodeBase:
    "8ea7988f430d71609693dbf58f7f750323119173ca1ead5d2db8284773daeff6",
  secondary: "",
  location: "Roving",
};

const Log = async (dataInput) => {
  if (!dataInput) dataInput = testInput;
  await API.graphql(
    graphqlOperation(createAgentResponse, { input: dataInput })
  );
};

export { Log };
